jQuery(document).ready(function($){

  function getOCOPColors(pid){
    return $.ajax({
      url: '/apps/ocop/php/productmetafields.php',
      method: 'post',
      data: {'pid':pid},
      dataType: 'json'
    });
  }

  function getOCOPProduct(pid){
    return $.ajax({
      url: '/apps/ocop/php/getproductimages.php',
      method: 'post',
      data: {'pid':pid},
    });
  } 

  function getOCOPProducts(pid){
    return $.ajax({
      url: '/apps/ocop/php/getproduct.php',
      method: 'post',
      data: {'pid':pid},
    });
  }

  function getOCOPVariants(pid){
    return $.ajax({
      url: '/apps/ocop/php/getvariants.php',
      method: 'post',
      data: {'pid':pid},
    });
  }

  /* ocop collection page - change photo when clicking color */
  $('body').on('click', '.ProductItem__ColorSwatchList.flex label', function(e){
    e.stopPropagation();

    let $this = $(this);
    let id = $(this).data('id');
    $this.parents('.ProductItem__ColorSwatchList.flex').find('label').removeClass('active');
    $this.addClass('active');
    $this.parents('.ProductItem__Wrapper').find('.ProductItem__Image').addClass('Image--lazyLoading');


    let owl = $this.parents('.ProductItem__Wrapper').find('.mobslider');
    owl.html('<span class="Image__Loader"></span><div class="owl-carousel"></div>');


    $.when(getOCOPProduct(id)).done(function(response){
      let product = $.parseJSON(response);
      let images = product.products[0].images;
      let mainimg, secimg;

      if(images[0]){
        mainimg = images[0].src;
      }

      if(images[1]){
        secimg = images[1].src;
      }
      else{
        secimg = images[0].src;
      }

      $this.parents('.ProductItem__Wrapper').find('.ProductItem__Image').removeClass('Image--lazyLoading');
      $this.parents('.ProductItem').find('.ProductItem__Image').eq(1).data('srcset', mainimg).attr('srcset', mainimg).attr('src', mainimg).hide().show();
      $this.parents('.ProductItem').find('.ProductItem__Image').eq(0).data('srcset', secimg).attr('srcset', secimg).attr('src', secimg).hide().show();
    

        images.forEach(function(e,i){
          owl.find('.owl-carousel').append('<div><img src="'+e.src+'" alt="'+e.alt+'" loading="lazy"></div>');
        })
        owl.find('.Image__Loader').remove();

        owl.find('.owl-carousel').owlCarousel({
          'items': 1,
          'dots': false,
          'nav': true,
          'margin': 5,
        });
    })
  })


  $('body').on('click', '.Cart__NoteButton', function(){
    $('.giftform').fadeIn();
    $('#sidebar-cart').addClass('has-note-open');
    $(this).hide();
  })


  $('body').on('click', '.giftform .Button--primary', function(){
    $('.giftform').hide();
    $('.Cart__NoteButton').show();
  })

  /* scroll on changing the products sorting order */
  $('body').on('click', '#bc-sf-filter-top-sorting button', function(){
    $('html,body').animate({scrollTop: 1 }, 'slow');
  });


  /* show more colors */
  $('body').on('click', '.ProductItem__ColorSwatchItem.more', function(){
    $(this).addClass('hidden').prevAll().css({'display':'inline-block'});
  })


  /* mobile submenu */
  $('#sidebar-menu button.Collapsible__Button.Heading').attr('aria-expanded', 'false').next('.Collapsible__Inner').height(0);


  /* header hover */
  $('.template-index #section-header, .p-accessibility #section-header, .p-spring-summer-2023 #section-header, .template-product #section-header, .template-collection #section-header, .p-our-stores #section-header, .p-about #section-header, .p-faq #section-header, .p-size-guide-2024 #section-header, .p-spring-summer-2024 #section-header, .p-one-of-twelve #section-header').hover(
  function() {
    $('#shopify-section-header').addClass('hovered');
  },
  function() {
    $('#shopify-section-header').removeClass('hovered');
  });


  /* check product variants */
  const checkSizes = () => {
    let color = $('.ColorSwatchList input:checked').val();

    $('.SizeSwatchList li').removeClass('soldout');


    $('.SizeSwatchList li input').each(function(){
      let size = $(this).val();
      let variantName = color + ' / ' + size;
      let available;
      $('.variantMatrix div').each(function(){
        if($(this).data('name')==variantName){
          available = $(this).data('available');
        }
      })
      
      if(available==false){
        $(this).parent('li').addClass('soldout');
      }
    })
  }

  const checkColors = () => {
    let size = $('.SizeSwatchList input:checked').val();

    $('.ColorSwatchList li').removeClass('soldout');

    $('.ColorSwatchList li input').each(function(){
      let color = $(this).val();
      let variantName = color + ' / ' + size;
      let available;
      $('.variantMatrix div').each(function(){
        if($(this).data('name')==variantName){
          available = $(this).data('available');
        }
      })
      
      if(available==false){
        $(this).parent('li').addClass('soldout');
      }
    })
  }

  $('.ColorSwatchList input').on('change', checkSizes);
  $('.SizeSwatchList input').on('change', checkColors);

  checkColors();
  // checkSizes();



  /* add thumbnails carousel */
  $('.Product__SlideshowNavScroller').flickity({
    asNavFor: '.Product__Slideshow',
    contain: true,
    pageDots: false,
    arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
  });




  /* scrolling down */
  var page = $('body'),
  howFar = 25;

  const changeMenu = () => {
    if($(document).scrollTop() > howFar){
      if(!page.hasClass('scrolled')){
        page.addClass('scrolled');
      }
    }
    else{
      if($(document).scrollTop() < 5){
        if(page.hasClass('scrolled')){
          page.removeClass('scrolled');
        }
      }
    }
  }
  changeMenu();
  $(document).scroll(changeMenu);



  /* filter "show results" */
  $('body').on('click', '.boost-pfs-filter-show-result', function(){
    $('.Drawer__Close').trigger('click');
  })





  /* mobile search button */
  $('#sidebar-menu .searchBtn').on('click', function(e){
    e.preventDefault();
    $('.Drawer__Close').trigger('click');
    $('#Search').attr('aria-hidden', false);
    $('.PageOverlay').addClass('is-visible');
    $('html').addClass('no-scroll');
    $('#shopify-section-header').css({'z-index':'10'});
    setTimeout(function(){
      $('.Search__Form > input').focus();
      $('.Search__Form > input').get(0).focus();
    }, 500)
  })


  /* faq */
  $('.question h4').on('click', function(){
    if($(this).hasClass('opened')){
      $(this).removeClass('opened').next('.ans').slideUp();
    }
    else{
      $(this).addClass('opened').next('.ans').slideDown();
    }
  })
 

  /* footer chat */
  $('#footer a[href="#chat"]').on('click', function(e){
    e.preventDefault();
    if($('#gorgias-chat-container .gorgias-chat-key-safhmg a.chatclose').length==0){
      $('#gorgias-chat-container .gorgias-chat-key-safhmg').append('<a class="chatclose">Close chat</a>');
    }
    GorgiasChat.open();
  })

  $('body').on('click', '.chatclose', function(e){
    e.preventDefault();
    GorgiasChat.close();
    $(this).remove();
  }) 



  /* gorgias notification */
  var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});

  initGorgiasChatPromise.then(async () => {
    let chatButton = $('#footer li a[href="#chat"]');
    if(GorgiasChat.isChatOnline()==true){
      chatButton.addClass('online');
    }
    else{
      chatButton.addClass('offline').append(' <span>(offline)</span>');
    }
  })



  const getMissingOCOP = () => {
    var swatches;
    if($('body').hasClass('template-collection')){
      $('.ProductItem').each(function(i,e){
        swatches = $(e).find('.ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem');

        if(swatches.length==0){
          let pid = $(e).parent('.Grid__Cell').data('id');

          $.when(getOCOPColors(pid)).done(function(response){
            let itemSwatchHtml = $('<div></div>');
            let ocopcolors = $.parseJSON(response.value);

            $.each(ocopcolors, function(ocopi, ocopp){

              let order = ocopp.order;
              if(ocopp.colortype=='seasonal'){
                order = order + 100;
              }

              let className;
              if(ocopp.ismain==true){
                className='active';
                order = -1;
                itemSwatchHtml.prepend('<div class="ProductItem__ColorSwatchItem" style="order:'+order+'" data-mainimg="" data-secimg=""><label class="ColorSwatch ColorSwatch--small '+className+'" style="background-color: '+ocopp.color+'; background-image: url(//suziekondi.com/cdn/shop/files/'+ocopp.color.replace(/\s+/g, '-')+'.png)" title="'+ocopp.color+'" data-tooltip="'+ocopp.color+'" data-id="'+ocopp.id+'"></label></div>');
              }
              else{
                itemSwatchHtml.append('<div class="ProductItem__ColorSwatchItem" style="order:'+order+'" data-mainimg="" data-secimg=""><label class="ColorSwatch ColorSwatch--small '+className+'" style="background-color: '+ocopp.color+'; background-image: url(//suziekondi.com/cdn/shop/files/'+ocopp.color.replace(/\s+/g, '-')+'.png)" title="'+ocopp.color+'" data-tooltip="'+ocopp.color+'" data-id="'+ocopp.id+'"></label></div>');
              }
            })

            if(ocopcolors.length>5){
              let more = ocopcolors.length-5;
              itemSwatchHtml.append('<div class="ProductItem__ColorSwatchItem more">+'+more+'</div>');
            }
            
            $('.ProductItem__ColorSwatchList.pid_'+pid).html(itemSwatchHtml);
          });
        }
      })
    }
  }

  //setInterval(getMissingOCOP, 1000);


  
  /* Footer - collapsing menu behaviour */
  /*$('#footer .menu ul li a div').on('click', function(e){
    e.preventDefault();
    const self = $(this);
    if(self.hasClass('opened')){
      self.removeClass('opened').html('+').parents('li').find('.submenu').slideUp();
    }
    else{
      self.addClass('opened').html('–').parents('li').find('.submenu').slideDown();
    }
  })*/

  $('footer#footer a[href="#oh"]').on('click', function(e){
    e.preventDefault();
  });

  $('footer#footer a[href="#oh"]').css({'text-decoration':'none', 'cursor':'default'}).attr('href','');



  /* open cart if needed */
  var url = window.location.href;
  if(url.indexOf('cart=1') != -1){
    $('.cartbtn')[0].click()
  }


  /* collection 2024 */
  var ocophideInterval = setInterval(function(){
    if($('.ProductList .ocophide').length>0){
      if($('body').hasClass('collection-2024')){
        $('.ProductList .ocophide').remove();
      }
      clearInterval(ocophideInterval);
    }
  }, 500);



  /* footer menu */
  $('#footer .menu>ul > li > a[href="#"]').on('click', function(e){
    e.preventDefault();
  })
  $('#footer .menu > ul > li > a > .arrow-icon').on('click', function(e) {

    if ($(window).width() <= 970) {

      e.preventDefault();

      let parent = $(this).closest('li');
      let submenu = parent.find('.submenu').first();
      let div = $(this).find('div');

      submenu.slideToggle();
      div.toggleClass('opened');

    }
  });




})